import emailjs from '@emailjs/browser';

export interface sendContactFormEmailProps {
  form: any;
  successCallback: () => void;
  errorCallback: () => void;
}

const sendContactFormEmail: (data: sendContactFormEmailProps) => void = ({ form, successCallback, errorCallback }) => {
  const serviceID: string = 'service_eob3gds';
  const publicKey: string = '7zkMivmPJmbu3-P_q';
  const templateID: string = 'template_wzdncas';

  emailjs
    .sendForm(serviceID, templateID, form, publicKey)
    .then(result => {
      successCallback();
    })
    .catch(error => {
      errorCallback();
    });
};

export default sendContactFormEmail;
